import { ReactComponent as DownloadIcon } from '../../Common/BootstrapIcons/download.svg';
import { ReactComponent as EditIcon } from '../../Common/BootstrapIcons/edit.svg';
import { ReactComponent as HistoryIcon } from '../../Common/BootstrapIcons/history.svg';
import { ReactComponent as ViewIcon } from '../../Common/BootstrapIcons/view.svg';
import { ReactComponent as ViewReleasedIcon } from '../../Common/BootstrapIcons/shield-check.svg';
import appRoutes from '../../../infrastructure/constants/appRoutes';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import history from '../../../infrastructure/helpers/react/history';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import identityStorage from '../../../infrastructure/authorization/identityStorage';
import React from 'react';
import ReportConfigGridItem from '../../../types/report/ReportConfigGridItem';
import urlHelper from '../../../infrastructure/helpers/common/urlHelper';
import writeUserRoles from '../../../infrastructure/constants/identity/writeUserRoles';
import EditableText from '../../Common/EditableText/EditableText';
import Spinner from '../../Common/Spinner/Spinner';

const uniqueName = 'global-module-config-grid';

const getColumns = (
    onEditClick: (id: number) => void,
    onDownloadClick: (id: number) => Promise<void>,
    onViewReleasedClick: (id: number) => void,
    showSpinnerOnDownload?: boolean,
    onMouseLeaveDerscription?: (configItem: ReportConfigGridItem, description: string) => void,
): ColumnDefinition<ReportConfigGridItem>[] => {

    let identity = identityStorage.get();

    let hasWriteRole = writeUserRoles.includes(identity.userRole);

    return [
        {
            header: 'Id',
            sortKey: 'Id',
            getContent: x => x.id.toString(),
            width: '46px'
        },
        {
            header: 'Name',
            sortKey: 'Name',
            getContent: x => <button className="transparent-button" onClick={() => onEditClick(x.id)}>{x.name}</button>,
            className: 'break-all'
        },
        {
            header: 'Description',
            sortKey: 'Description',
            getContent: x => <EditableText onMouseLeave={(value: string) => onMouseLeaveDerscription && onMouseLeaveDerscription(x, value)}
                value={x.description}
                multiline={true} disabled={false} />,
            className: 'break-all'
        },
        {
            header: 'Stage',
            sortKey: 'IsReleased',
            getContent: x => x.isReleased ? 'Released' : 'Unreleased',
            width: '90px'
        },
        {
            header: 'Version Number',
            sortKey: 'ReleaseNumber',
            getContent: x => x.releaseNumber > 0 ? x.releaseNumber.toString() : '-',
            width: '130px'
        },
        {
            header: 'Actions',
            getContent: x =>
                <div className='display-flex align-items-center'>
                    <button className="custom-icon-button" onClick={() => history.push(urlHelper.buildUrl(appRoutes.reporting.changeLog, { name: x.name, id: x.id, redirect: encodeURIComponent(appRoutes.reporting.home) }))}>
                        <CustomIcon icon={HistoryIcon} title={iconTooltip.changeLog} />
                    </button>
                    <button className="custom-icon-button" onClick={() => onEditClick(x.id)}>
                        {
                            hasWriteRole ?
                                <CustomIcon icon={EditIcon} title={iconTooltip.edit} />
                                : <CustomIcon icon={ViewIcon} title={iconTooltip.view} />
                        }
                    </button>
                    <button className="custom-icon-button" onClick={() => onViewReleasedClick(x.id)}>
                        <CustomIcon icon={ViewReleasedIcon} title={iconTooltip.viewReleased} />
                    </button>

                    {showSpinnerOnDownload ?
                        <Spinner /> :
                        <button className="custom-icon-button button-spinner-font-size" onClick={() => onDownloadClick(x.id)}>
                            <CustomIcon icon={DownloadIcon} title={iconTooltip.download} />
                        </button>
                    }
                </div>,
            className: 'display-flex',
            width: '300px'
        }
    ];
};

export { getColumns, uniqueName };